export { default } from "./AppliedFilters.jsx";
